import { render, staticRenderFns } from "./textButton.vue?vue&type=template&id=0b9bc524&"
import script from "./textButton.vue?vue&type=script&lang=ts&"
export * from "./textButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports